import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
// import { Select, DatePicker, Form, Modal, Input } from "antd";
// import { Calendar, momentLocalizer } from "react-big-calendar";
// import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Ui, Translate } from "../../services";
import Api from "../../services/ServiceApi";
// const localizer = momentLocalizer(moment);
// const { Option } = Select;
// const { RangePicker } = DatePicker;

class PlanningJob extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: "Planning Jobs",
      active: 0,
      events: [
        {
          start: new Date(),
          end: new Date(),
          // title: "ICE",
        },
        // {
        //   start: new Date(),
        //   end: new Date(),
        //   title: "นายวรรษ เฟื่องจันทร์",
        // },
        // {
        //   start: new Date(),
        //   end: new Date(),
        //   title: "นายวรรษ เฟื่องจันทร์",
        // },
        // {
        //   start: new Date(),
        //   end: new Date(),
        //   title: "นายวรรษ เฟื่องจันทร์",
        // },
        // {
        //   start: new Date(),
        //   end: new Date(),
        //   title: "นายวรรษ เฟื่องจันทร์",
        // },
      ],
      visible: false,
    };
  }

  componentDidMount() {
    document.title = this.state.title;
    console.log("start");
  }

  onSelectMonth = () => {
    console.log("select");
  };

  onModal(name, mode, visible) {
    if (visible == false) {
      this.formRef.current.resetFields();
    }

    if (name == "main") {
      this.setState({
        visible: visible,
        mode,
      });
    } else {
      this.setState({
        visible_sub: visible,
        mode,
      });
    }
  }

  handleAdd = (value) => {
    console.log("value====>", value);

    // var events = this.state.events
    // events.push({
    //     start: moment(value.date[0]).toDate(),
    //     end: moment(value.date[1]).toDate(),
    //     title: value.maintenance_name
    // })
    // this.setState({
    //     events: events,
    //     visible: false
    // })
    this.formRef.current.resetFields();
  };

  onSelectTab(active) {
    this.setState({ active });
  }

  render() {
    const {  title, active } = this.state;
    return (
      <LayoutOperation active={4}>
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/planning_job_white.svg")}
                  className="mr-3"
                  alt=""
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                  {title}
                </h2>
              </div>
              <div className="col-6">
                <div className="row justify-content-center">
                  <div className="col-3">
                    <div className="d-flex justify-content-between align-items-center">
                      {/* <span className="font-thai-b c-white font14">
                        Total Jobs
                        <br />
                        today
                      </span>
                      <div className="stat d-flex align-items-center">
                        <span className="font-thai-b font30 c-yellow w-100 text-center">
                          600
                        </span>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-3 offset-1">
                    <div className="d-flex justify-content-between align-items-center">
                      {/* <span className="font-thai-b c-white font14">
                        Total Jobs
                        <br />
                        Monthly
                      </span>
                      <div className="stat d-flex align-items-center">
                        <span className="font-thai-b font30 c-yellow w-100 text-center">
                          130
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="card-table-ma my-2">
              <ul className="nav">
                <li className="nav-item font12 font-mont-sb mr-1">
                  <a
                    className={active == 0 ? "nav-link active" : "nav-link"}
                    onClick={() => this.onSelectTab(0)}
                  >
                    <Translate text="tab_planning_list" />
                  </a>
                </li>
                <li className="nav-item font12 font-mont-sb mr-1">
                  <a
                    className={active == 1 ? "nav-link active" : "nav-link"}
                    onClick={() => this.onSelectTab(1)}
                  >
                    <Translate text="tab_calendar" />
                  </a>
                </li>
              </ul>
              {active === 0 ? <Ui.ListPlan /> : <Ui.CalendarPlan />}
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default PlanningJob;
